import { ISelectData } from '../ui/Selects/select/model'

export const objectToSelectData = <T extends Record<string, string | number>>(
  obj: T
): ISelectData[] => {
  return Object.entries(obj)
    .filter(([, value]) => typeof value === 'number')
    .map(([key, value]) => ({
      label: key,
      value: Number(value)
    }))
}
